var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPodcast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99983 11.6667C11.3832 11.6667 12.4998 10.55 12.4998 9.16669V4.16669C12.4998 2.78335 11.3832 1.66669 9.99983 1.66669C8.61649 1.66669 7.49983 2.78335 7.49983 4.16669V9.16669C7.49983 10.55 8.61649 11.6667 9.99983 11.6667ZM14.9248 9.16669C14.5165 9.16669 14.1748 9.46669 14.1082 9.87502C13.7665 11.8334 12.0582 13.3334 9.99983 13.3334C7.94149 13.3334 6.23316 11.8334 5.89149 9.87502C5.82483 9.46669 5.48316 9.16669 5.07483 9.16669C4.56649 9.16669 4.16649 9.61669 4.24149 10.1167C4.64983 12.6167 6.64983 14.575 9.16649 14.9334V16.6667C9.16649 17.125 9.54149 17.5 9.99983 17.5C10.4582 17.5 10.8332 17.125 10.8332 16.6667V14.9334C13.3498 14.575 15.3498 12.6167 15.7582 10.1167C15.8415 9.61669 15.4332 9.16669 14.9248 9.16669Z",
    fill: "#3367CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodcast);
export default __webpack_public_path__ + "static/media/podcast.16e06e70.svg";
export { ForwardRef as ReactComponent };